export default __webpack_public_path__ + "static/media/plain-sticker-p.2f4ab4a1.png";